<div id="nav-v2" class="p-fixed d-flex">
  <div class="main w-44px space-between-vert align-items-c">
    <div class="centered-content flex-d-c w-full pt-11px">
      <img src="dist/img/gtmhub-circle-logo.svg" class="mb-10px" />
      <ng-container *ngFor="let screen of screens">
        <a
          class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"
          *ngIf="(screen.showScreenCondition$ | async) || !screen.showScreenCondition$"
          (click)="setActive(screen)"
          ui-tooltip
          [uiTooltipTitle]="screen.key | localize"
          tooltipPosition="right"
          [gh-sref]="getState(screen)"
          [ngClass]="'gh-font-icon-' + screen.icon"
          [class.bg-white]="activeScreen === screen.key">
        </a>
      </ng-container>
    </div>
    <div class="centered-content flex-d-c pb-11px w-full">
      <a
        href="/marketplace"
        (click)="setMarketplaceCookie()"
        gh-dropdown-toggle
        class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full gh-font-icon-add-from-marketplace"
        *ngIf="showMarketplace$ | async"
        ui-tooltip
        [uiTooltipTitle]="'marketplace' | localize"
        tooltipPosition="right">
      </a>
      <a
        class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"
        *ngIf="(settingsScreen.showScreenCondition$ | async) || !settingsScreen.showScreenCondition$"
        (click)="setActive(settingsScreen)"
        ui-tooltip
        [uiTooltipTitle]="settingsScreen.key | localize"
        tooltipPosition="right"
        [gh-sref]="settingsScreen.state"
        [ngClass]="'gh-font-icon-' + settingsScreen.icon"
        [class.bg-white]="activeScreen === settingsScreen.key">
      </a>

      <div class="w-full centered-horiz" ui-tooltip [uiTooltipTitle]="'support_center' | localize" tooltipPosition="right">
        <gh-dropdown [menuItems]="helpMenuItems" [dropUp]="true">
          <ui-icon uiTheme="outline" uiType="help" gh-dropdown-toggle class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"></ui-icon>
        </gh-dropdown>
      </div>

      <button
        *ngIf="{ count: unreadNotificationsCount$ | async } as context"
        class="notif-btn h-40px w-full"
        (click)="openNotificationsModal(context.count)"
        ui-tooltip
        [uiTooltipTitle]="'notifications' | localize"
        tooltipPosition="right">
        <ui-badge [uiCount]="context.count" [uiStyle]="{ right: '2px' }" [uiOffset]="[-2, 0]">
          <ui-icon class="ink-20-v3 fs-16px" uiTheme="outline" uiType="notifications"></ui-icon>
        </ui-badge>
      </button>

      <gh-dropdown [menuItems]="profileMenuItems" [dropUp]="true" class="mt-18px" dropdownMenuClass="l--13px">
        <ui-avatar gh-dropdown-toggle uiType="picture" [uiPicture]="profile.picture" uiSize="sm"></ui-avatar>
      </gh-dropdown>
    </div>
  </div>
  <sub-navigation [activeScreen]="activeScreen"></sub-navigation>
</div>
